module.exports = __webpack_public_path__ + "static/media/dexter-pink.98fb6235.svg";